import React from 'react';
import { HelmetProvider } from 'react-helmet-async';
import Layout from '../components/Layout';
import Hero from '../components/Hero';
import ServiceFeatures from '../components/ServiceFeatures';
import ApplicationForm from '../components/ApplicationForm';
import LineContact from '../components/LineContact';
import SEO, { homePageSEO } from '../components/SEO';

const Home: React.FC = () => {
  return (
    <HelmetProvider>
      <SEO {...homePageSEO} />
      <Layout>
        <Hero />
        <ServiceFeatures />
        <ApplicationForm />
        <LineContact />
      </Layout>
    </HelmetProvider>
  );
};

export default Home;